module.exports = __webpack_public_path__ + "img/edit-icon.a4df02b6.svg";